import { render } from "./WidgetInboundGraph.vue?vue&type=template&id=732a7ec8&ts=true"
import script from "./WidgetInboundGraph.vue?vue&type=script&lang=ts"
export * from "./WidgetInboundGraph.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__